import { render, staticRenderFns } from "./MediabankBrowser.vue?vue&type=template&id=4f9cfed7&scoped=true&"
import script from "./MediabankBrowser.vue?vue&type=script&lang=js&"
export * from "./MediabankBrowser.vue?vue&type=script&lang=js&"
import style0 from "./MediabankBrowser.vue?vue&type=style&index=0&id=4f9cfed7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9cfed7",
  null
  
)

export default component.exports